import React, {useEffect, useState} from "react";
import {BrowserRouter as Router} from "react-router-dom";
import AppLayout from "./containers/AppLayout";
import './utils/Loader';
import auth from "./api/auth";
import HeaderButtons from "./components/HeaderButtons";

function App() {
    const [loggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
        setLoggedIn(auth.isAuthenticated())
    }, [auth.isAuthenticated()])

    return (
        <>
            <Router>
                <div className="user-login-header">
                    <div className="user-details">
                        <HeaderButtons loggedIn={loggedIn} />
                    </div>
                </div>
                <AppLayout/>
            </Router>
        </>

    );
}

export default App;
